import CheckoutPaymentFormDetailsB2C from './components/CheckoutPaymentFormDetailsB2C';
import CheckoutPaymentFormDetailsB2B from './components/CheckoutPaymentFormDetailsB2B';
import { translate } from '../../../../../../../../Services/translation';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  setAlternativeCompanyAddress,
  setCustomerDetails,
} from '../../../../../../../../Actions/Checkout.action';
import constants from '../../../../../../../../constants';
import { useDispatch } from 'react-redux';

const CheckoutPaymentFormDetails = ({ checkout }) => {
  const { payload } = checkout;
  const {
    authenticated,
    customerDetails,
    isBusinessCustomer,
    checkoutMode,
    b2BCheckoutInfo,
    loginUrl,
  } = payload;

  const dispatch = useDispatch();

  const onCustomerDetailsChange = (stateKey, propName, value) => {
    switch (stateKey) {
      case 'customerDetails':
        dispatch(setCustomerDetails(propName, value));
        break;
      case 'alternativeCompanyAddress':
        dispatch(setAlternativeCompanyAddress(propName, value));
        break;
    }
  };

  useEffect(() => {
    // fill default select value to the state
    if (
      customerDetails &&
      !customerDetails.country &&
      constants?.countries?.[0]
    ) {
      dispatch(setCustomerDetails('country', constants.countries[0].value));
    }
  }, [customerDetails, dispatch]);

  return (
    <>
      {authenticated && isBusinessCustomer && b2BCheckoutInfo && (
        <div
          className="rich-text mb-8 last:mb-0"
          dangerouslySetInnerHTML={{ __html: b2BCheckoutInfo }}
        />
      )}

      <h3 className="body body_bold mb-4 last:mb-0">
        {translate('checkout.customerinfo.title')}
      </h3>

      {!authenticated &&
        !isBusinessCustomer &&
        checkoutMode === constants?.checkoutMode?.both && (
          <div className="mb-4 last:mb-0">
            <a href={loginUrl} className="link">
              {translate('checkout.customerinfo.already_customer_sign_in')}
            </a>
          </div>
        )}

      {(
        authenticated
          ? isBusinessCustomer
          : checkoutMode === constants?.checkoutMode?.companyCustomers ||
            isBusinessCustomer
      ) ? (
        <CheckoutPaymentFormDetailsB2B
          checkout={checkout}
          onChange={onCustomerDetailsChange}
        />
      ) : (
        <CheckoutPaymentFormDetailsB2C
          checkout={checkout}
          onChange={onCustomerDetailsChange}
        />
      )}
    </>
  );
};

CheckoutPaymentFormDetails.propTypes = {
  checkout: PropTypes.object.isRequired,
};

export default CheckoutPaymentFormDetails;
